<template>
  <div class="powerpack-image-container" :class="{ mobile: device === 'mobile' }">

    <powerpack-image/>

    <div class="share-popup d-md-flex" @click="openShareModal">
      <img src="../../assets/share.png">
      <span class="sub-title">{{ $t('general.share') }}</span>
    </div>

    <powerpack-dimension/>

    <!-- Share modal -->
    <popup-share
        v-if="shareModal"
        :shareLink="shareLink"
        @close="shareModal = false"/>
  </div>
</template>

<script>
import Popup from "../popup/Popup";
import PopupBlueprint from "../popup/PopupBlueprint";
import PopupShare from "../popup/PopupShare";
import {mapGetters, mapState} from "vuex";
import PowerpackDimension from "./PowerpackDimension";
import PowerpackImage from "./PowerpackImage";
import {getShareUrl} from "@/helpers/route";

export default {
  name: "PowerpackImageContainer",

  data() {
    return {
      shareModal: false,
      shareLink: "",
      error: '',
      files: [],
    }
  },

  components: {
    PopupBlueprint,
    PopupShare,
    Popup,
    PowerpackDimension,
    PowerpackImage,
  },

  methods: {
    openShareModal() {
      this.$store.dispatch('cart/getBuildId').then((buildId => {
        if (buildId) {
          this.shareLink =
              this.shareLink = getShareUrl(buildId);
        }
        this.shareModal = true;
      }));
    },
  },

  computed: {
    ...mapState({
      magentoLoggedIn: state => state.preference.magentoLoggedIn,
      pumpIndex: state => state.build.pump,
      byPumpId: state => state.pumps.byId,
      tankIndex: state => state.build.tank,
      byTankId: state => state.tanks.byId,
      powerpackOptions: state => state.powerpackOptions.all,
      allValves: state => state.valves.all,
      circuit: state => state.circuits.all,
      activeCircuit: state => state.build.circuit,
      motors: state => state.motors.all,
      motorId: state => state.build.motor,
      totalHeight: state => state.build.dimensions.totalHeight,
      totalLength: state => state.build.dimensions.totalLength,
      totalWidth: state => state.build.dimensions.totalWidth,
    }),
    ...mapGetters({
      types: 'pumps, tanks',
      dimensions: 'build/getDimensions',
      motorOption: 'build/getMotorOption',
      device: 'getDevice',
    }),
    activeValve() {
      return {name: 'not found', image: 'placeholder'};
    },
    activeMotor() {
      for (const motor of this.motors) {
        if (motor.id === this.motorId) {
          return motor;
        }
      }
      return {name: 'not found', image: 'placeholder'};
    },

    activePump() {
      let id = this.pumpIndex > 0 ? this.pumpIndex : 1;
      return this.byPumpId[id];
    },

    activeTank() {
      let id = this.tankIndex > 0 ? this.tankIndex : 1;
      return this.byTankId[id];
    },
  },
}
</script>

<style lang="scss">

.powerpack-image-container {
  padding-bottom: 40px;
  margin-bottom: 40px;
}

.download-step {
  display: flex;
  margin-top: 20px;
  width: 100%;

  @media only screen and (max-width: 375px) {
    margin-bottom: 5px;
  }

  .download-btn {
    border: none;
    outline: none;
    background-color: #3DB0C7;
    color: white;
    font-size: 12px;
    font-family: neue-haas-grotesk-display, sans-serif;
    letter-spacing: 0.5px;
    transition: all ease 0.3s;
    opacity: 1;
    text-decoration: none;
    padding: .375rem .75rem;
    height: 32px;

    &:hover {
        background-color: #236c7b;
    }

    &:disabled {
      cursor: not-allowed;
      background: #D7D7D7;
    }
  }
  .error {
    width: 170px;
    text-align: center;
    position: absolute;
    top: 32px;
    left: 0;
    font-size: 12px;
  }
}

.powerpack-image-container {
  position: relative;
}

.schema-popup {
  margin-left: auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  border: 2px solid #3DB0C7;
  border-radius: 50px;
  height: 40px;
  cursor: pointer;
  padding: 0 5px;
  transition: all ease 0.3s;
  position: absolute;
  bottom: 0;
  right: 0;

  img {
    margin-right: 4px;
    transition: all ease 0.3s;
    transform: translateY(-2px) scale(1.2);
  }

  &:hover {
    background-color: lighten(#3DB0C7, 30%);

    img {
      transform: scale(1.5);
    }
  }
}

.share-popup {
  left: 0;
  right: initial;
  justify-content: flex-start;
  height: 40px;
  padding-right: 20px;
  align-items: center;
  border: 2px solid #3DB0C7;
  border-radius: 50px;
  cursor: pointer;
  position: absolute;
  bottom: 0;
  display: flex;

  img {
    transition: all ease 0.3s;
    transform: scale(0.3);
  }

  &:hover {
    background-color: lighten(#3DB0C7, 30%);

    img {
      transform: scale(0.35);
    }
  }
}
</style>
